import * as React  from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useEffect,useState } from 'react';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


export default function CustomizedMenus({ ButtonName, onEdit, onView, onSave, onLock, ListType,EditData,totalData }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [data,setData] =useState({})
    const handleClick = (event) => {
        if(totalData?.Is_Locked == "true"){}
        else{
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(()=>{
setData(EditData)
    },[EditData])

    return (
        <div>
            <Button
                id="menu-button"
                aria-controls={open ? 'customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={ totalData?.Is_Locked == "true"  ? "" : <KeyboardArrowDownIcon />}
            >
                {ButtonName}
            </Button>
            <StyledMenu
                id="customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'menu-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {
                    ListType == "list"  || EditData?.Month_Name !== ButtonName ?
                        <>
                            <MenuItem
                                onClick={() => {
                                    handleClose();
                                    onEdit?.(); // optional chaining
                                }}
                                disableRipple
                            >
                                <EditIcon />
                                Edit
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    handleClose();
                                    onLock?.();
                                }}
                                disableRipple
                            >
                                <LockIcon />
                                Lock
                            </MenuItem>
                        </>
                        : ''}
                {
                    ListType == "edit" && EditData?.Month_Name == ButtonName ?
                        <>
                            <MenuItem
                                onClick={() => {
                                    handleClose();
                                    onView?.();
                                }}
                                disableRipple
                            >
                                <VisibilityIcon />
                                View
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    handleClose();
                                    onSave?.();
                                }}
                                disableRipple
                            >
                                <SaveIcon />
                                Save
                            </MenuItem>
                        </>
                        : ''}

            </StyledMenu>
        </div>
    );
}
